import React, { useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styled, { StyleSheetManager } from 'styled-components';
import Header from './../elementos/basicos/Header';
import CabeceraCursos from '../elementos/basicos/Cabecera';
import ContenedorCards from '../elementos/basicos/ContenedorCards';
import CardCursoArea from '../elementos/basicos/CardCursoArea';
import Boton from '../elementos/eventos/Boton';
import Footer from '../elementos/basicos/Footer';
import { getCursosAleatorios } from '../../peticiones_API/Peticiones_Areas';

// Home: 8 cursos aleatorios del sistema NUEVO de áreas (sepe_cursos con
// activo=1 + publicado_web=1). Cada carga cambia el orden (RAND() en backend).
// La card enlaza a /areas/:slug/:cursoUrl usando la primera área del curso.
const CursosInicio = () => {
  const [cursos, setCursos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let activo = true;
    setLoading(true);
    setError(false);
    getCursosAleatorios(8)
      .then((data) => { if (activo) setCursos(Array.isArray(data) ? data : []); })
      .catch((err) => {
        if (!activo) return;
        console.error('Ha habido un error:', err);
        setError(true);
      })
      .finally(() => { if (activo) setLoading(false); });
    return () => { activo = false; };
  }, []);

  return (
    <>
      <Header />
      <StyleSheetManager shouldForwardProp={() => true}>
        <CabeceraCursos
          Titulo="CURSOS GRATUITOS"
          Subtitulo="100% SUBVENCIONADOS Y ONLINE"
          Texto_1="Sea cual sea tu situación laboral, encuentra el curso que mejor se ajuste a tus necesidades."
          Texto_2="¡Plazas limitadas, no dejes pasar esta oportunidad!"
          color_cabecera="true"
        />
      </StyleSheetManager>

      <ContenedorCards>
        <h2>Nuestros cursos</h2>

        {loading ? (
          <Row className="justify-content-center">
            {Array.from({ length: 8 }).map((_, i) => (
              <ColCard lg="3" sm="12" md="4" key={i}>
                <Skeleton />
              </ColCard>
            ))}
          </Row>
        ) : error ? (
          <Mensaje>No se pudieron cargar los cursos. Vuelve a intentarlo en unos minutos.</Mensaje>
        ) : cursos.length === 0 ? (
          <Mensaje>Estamos preparando nuevos cursos. Vuelve pronto.</Mensaje>
        ) : (
          <Row className="justify-content-center">
            <CardCursoArea cursos={cursos} />
          </Row>
        )}

        <Boton alineado="true" to="/areas">DESCUBRE MÁS CURSOS</Boton>
      </ContenedorCards>

      <Footer />
    </>
  );
};

// Skeleton de carga: 8 placeholders del tamaño exacto de CardCursoArea
// (16.5rem × 24rem). Sin spinner central.
const ColCard = styled(Col)`
  margin-top: 5% !important;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Skeleton = styled.div`
  width: 16.5rem;
  height: 24rem;
  border-radius: 0.25rem;
  background: #ececec;
  background-image: linear-gradient(90deg, #ececec 0px, #f5f5f5 40px, #ececec 80px);
  background-size: 600px;
  animation: skeletonShimmer 1.4s infinite linear;

  @keyframes skeletonShimmer {
    0% { background-position: -300px; }
    100% { background-position: 300px; }
  }
`;

const Mensaje = styled.p`
  text-align: center;
  font-family: 'Montserrat', sans-serif;
  color: #666;
  font-size: 1.05rem;
  padding: 4vh 1rem;
  margin: 0;
`;

export default CursosInicio;
